import { render } from "./PremiumTableLoading.vue?vue&type=template&id=5d8ac600"
import script from "./PremiumTableLoading.vue?vue&type=script&lang=js"
export * from "./PremiumTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__